import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles, withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Stepper, Step, StepLabel, StepConnector, Snackbar, Typography, CircularProgress } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Check from '@material-ui/icons/Check';
import Button from '@material-ui/core/Button';
import useReactRouter from 'use-react-router';
import TextField from '@material-ui/core/TextField';
import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';
import { useInputChange } from '../../Helpers/useInputChange'
import axios from '../../Helpers/Axiosbase'
import * as actions from '../../Store/Actions'
import MuiAlert from '@material-ui/lab/Alert';
import "./styles.css";
import ace from 'brace';
import 'brace/mode/json';
import 'brace/theme/github';
// import {ReactAce  as Editor} from 'react-ace-editor';

//View
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';
import CodeIcon from '@material-ui/icons/Code';

import NavmenuForm from './NavmenuForm';
import EntityCreateForm from './EntityCreateForm'
import WizardEntityCreateForm from './WizardEntityCreateForm'
import EntityHeaderForm from './EntityHeaderForm'
import EntitySearchResultForm from './EntitySearchResultForm'

//Fullscreen
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#784af4',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#784af4',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
  root: {
    color: '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
  },
  active: {
    color: '#784af4',
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  completed: {
    color: '#784af4',
    zIndex: 1,
    fontSize: 18,
  },
  jsoneditor: {
    height: '300px'
  }
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? <Check className={classes.completed} /> : <div className={classes.circle} />}
    </div>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
};

const theme = createMuiTheme({
  typography: {
    subtitle1: {
      fontSize: 20,
      fontStyle: 'bold',
    },
  }
});

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  div: {
    marginRight: '15px',
    float: 'right',
  },
  textfield: {
    margin: theme.spacing(3)
  },
  btnformview: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    fontSize: '0.600rem',
  },
  //loader
  loader: {
    position: 'absolute',
    left: '65%',
    top: '350px',
  },
}));

function getSteps() {
  return ['Select Context', 'Create JSON'];
}

export default function AddConfigurationStepper() {
  const classes = useStyles();
  const { history, location } = useReactRouter();
  const { dispatch } = useDispatch();
  const [activeStep, setActiveStep] = React.useState(location.state != null ? 1 : 0);
  const [disabled, setDisabled] = React.useState(true);
  const steps = getSteps();

  //AutoComplete
  const top100Films = ["test", "testing"
    // { title: 'The Shawshank Redemption', year: 1994 },
    // { title: 'testing', year: 1995 },
    // { title: 'testrole', year: 1996 },
  ]

  //progressbar

  const [loader, setLoader] = React.useState(true)

  const [errorMessage, setErrorMessage] = React.useState({
    open: false,
    errmsg: null,
    api: ''
  });
  const [errorDuplicateMessage, setErrorDuplicateMessage] = React.useState({
    open: false,
    errmsg: "Duplicate Configuration",
  });

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
  };

  const reduxAuth = useSelector((state) => state.auth)
  const appcomponent = useSelector((state) => state.appcomponent)
  const [addConfigResponse, setAddConfigurationResponse] = React.useState(null);
  const [jsonObj] = React.useState({
    jsonDocument: {
      id: "",
      name: "",
      type: "",
      // properties:"",
      data: {
        contexts: [{
          context: {
            component: "_DEFAULT",
            role: "_DEFAULT",
            tenant: "_DEFAULT",
            domain: "_DEFAULT",
            app: "_DEFAULT",
            entityType: "_DEFAULT",
            country: "_DEFAULT",
            channel: "_DEFAULT",
            relationship: "_DEFAULT",
            user: "_DEFAULT"
          },
          jsonData: {}
        }]
      }
    }
  })

  //Base config State
  const [state, setState] = React.useState({
    baseConfig: []
  });

  //Context Selector
  const [input, setInput] = useInputChange({
    componentContextCode: appcomponent.selectedComponent.componentContextCode,
    domain: "_DEFAULT",
    entityType: "_DEFAULT",
    relationship: "_DEFAULT",
    role: "_DEFAULT",
    user: "_DEFAULT"
  });

  //Json Editor
  const [change, setChange] = React.useState({
    jsonData: location.state != null ? location.state.jsonDocument.data.contexts[0].jsonData : state.baseConfig
    // jsonData: state.baseConfig!=null ? state.baseConfig[0].jsonDocument.data.contexts[0].jsonData:{}
    // jsonData:{}
  })
  const handleOnChange = (event) => {
    setChange({
      jsonData: event
    })
  }

  const handleNext = (event) => {

    //Base Configurations Get
    let url = "baseConfigurationGet"
    let postdata = {
      userId: reduxAuth.userId,
      token: reduxAuth.token,
      environmentId: appcomponent.selectedEnvironment.tenantId,
      componentContextCode: appcomponent.selectedComponent.componentContextCode
    }

    axios.post(url, postdata)
      .then(baseConfigResponse => {
        state.baseConfig = baseConfigResponse.data.response[0].jsonDocument.data.contexts[0].jsonData;
        setChange({ jsonData: baseConfigResponse.data.response[0].jsonDocument.data.contexts[0].jsonData })
      })
      .catch(err => {
        if (typeof err.response != "object") {
          setErrorMessage({
            open: true,
            // errmsg:err
          })
          console.log(err);
        }
        else {
          if (err.response.status === 403) {
            dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
          }
        }
      });



    // Configuration Create
    if (event === "Next") {
      if (input._id == null) {
        let url = "configurationCreate"
        let postdata = {
          ...contextdp,
          jsonDocument: '',
          environmentId: appcomponent.selectedEnvironment.tenantId,
          isPublished: false,
          token: reduxAuth.token,
          userId: reduxAuth.userId
        }
        axios.post(url, postdata)
          .then(configResponse => {
            setAddConfigurationResponse(configResponse);
            setActiveStep(prevActiveStep => prevActiveStep + 1);
          })
          .catch(err => {
            if (err.response.status === 800) {
              setErrorDuplicateMessage({
                open: true,
                // errmsg:err
              })
            }
            if (typeof err.response != "object") {
              setErrorMessage({
                open: true,
              })
              console.log(err);
            }
            else {
              if (err.response.status === 403) {
                dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
              }
            }
          });
      }
    }
    else {
      // Configuration Update
      let url = "configurationUpdate"
      let postdata = null;
      if (input._id == null) {
        jsonObj.jsonDocument.data.contexts[0].jsonData = change.jsonData;
        jsonObj.jsonDocument.id = addConfigResponse.data.response.computedName;
        jsonObj.jsonDocument.name = addConfigResponse.data.response.computedName;
        jsonObj.jsonDocument.type = "UiConfig";
        jsonObj.jsonDocument.data.contexts[0].context.component = addConfigResponse.data.response.componentContextCode;
        jsonObj.jsonDocument.data.contexts[0].context.role = addConfigResponse.data.response.role;
        jsonObj.jsonDocument.data.contexts[0].context.tenant = addConfigResponse.data.response.tenant;
        jsonObj.jsonDocument.data.contexts[0].context.domain = addConfigResponse.data.response.domain;
        jsonObj.jsonDocument.data.contexts[0].context.entityType = addConfigResponse.data.response.entityType;
        jsonObj.jsonDocument.data.contexts[0].context.relationship = addConfigResponse.data.response.relationship;
        jsonObj.jsonDocument.data.contexts[0].context.app = addConfigResponse.data.response.app;
        jsonObj.jsonDocument.data.contexts[0].context.user = addConfigResponse.data.response.user;

        postdata = {
          _id: addConfigResponse.data.response._id,
          jsonDocument: jsonObj.jsonDocument,
          isPublished: false,
          componentContextCode: addConfigResponse.data.response.componentContextCode,
          domain: addConfigResponse.data.response.domain,
          entityType: addConfigResponse.data.response.entityType,
          context1: addConfigResponse.data.response.context1,
          context2: addConfigResponse.data.response.context2,
          context3: addConfigResponse.data.response.context3,
          relationship: addConfigResponse.data.response.relationship,
          role: addConfigResponse.data.response.role,
          app: addConfigResponse.data.response.app,
          isDuplicate: addConfigResponse.data.response.isDuplicate,
          environmentId: addConfigResponse.data.response.environmentId,
          token: reduxAuth.token,
          userId: reduxAuth.userId
        };
      }

      axios.post(url, postdata)
        .then(response => {
          // console.log(response);
          history.push("/Config");
          // dispatch(actions.configuration());
        })
        .catch(err => {
          console.log(err);
          if (typeof err.response != "object") {
            setErrorMessage({
              open: true,
              // errmsg:err
            })
            console.log(err);
          }
          else {
            if (err.response.status === 403) {
              dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
            }
          }
        });
        reduxAuth.fullscreentoggle=false
    }
  };

  const handleCancle = () => {
    reduxAuth.fullscreentoggle=false
    history.push("/Config");
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
    setOpenJSONView({
      open: false
    })
  };

  //ToggleView
  const [toggleView, setToggleView] = React.useState({
    view: 'form',
  });

  //Toggle View - handleViewBtnClick
  const handleViewBtnClick = (event) => {
    if (event === 'form') {
      setToggleView({
        view: 'form'
      })
      setOpenJSONView({
        open: false
      })
    }
    if (event === 'json') {
      setToggleView({
        view: 'json'
      })
      setOpenJSONView({
        open: true
      })
      setChange({
        jsonData: location.state != null ? location.state.jsonDocument.data.contexts[0].jsonData : state.baseConfig
      })
    }
    // console.log("locationstate-add",location.state)
  }

  const [openJSONView, setOpenJSONView] = React.useState({
    open: false,
  });

  //context dropdown
  const [EntityType, setEntityType] = React.useState([])
  const [Domain, setDomain] = React.useState(["thing", "party", "referenceData", "location"])
  const [Role, setRole] = React.useState([])
  const [Relationship, setRelationship] = React.useState([])
  const [User, setUser] = React.useState([])
  const [contextdp, setcontextdp] = React.useState({

    componentContextCode: appcomponent.selectedComponent.componentContextCode,
    domain: "_DEFAULT",
    entityType: "_DEFAULT",
    relationship: "_DEFAULT",
    role: "_DEFAULT",
    user: "_DEFAULT"

  })
  const handlecontextdropdown = (event, value) => {
    if (value === null) {
      value = "_DEFAULT"
    }
    if (event.currentTarget.id.includes("Select Domain")) {
      setcontextdp({
        ...contextdp,
        domain: value
      })
    }
    if (event.currentTarget.id.includes("Select EntityType")) {
      setcontextdp({
        ...contextdp,
        entityType: value
      })
    }
    if (event.currentTarget.id.includes("Select Relationship")) {
      setcontextdp({
        ...contextdp,
        relationship: value
      })
    }
    if (event.currentTarget.id.includes("Select Role")) {
      setcontextdp({
        ...contextdp,
        role: value
      })
    }
    if (event.currentTarget.id.includes("select User")) {
      setcontextdp({
        ...contextdp,
        user: value
      })
    }

  }
  const handlefullscreen=(value)=>{
    if(value==="Fullscreen")
    {
        reduxAuth.fullscreentoggle=true
    }
    else{
        reduxAuth.fullscreentoggle=false
    }
    console.log("location.state",location.state)
    history.push("./AddConfiguration",location.state)
}


  useEffect(() => {
    // console.log(location.state);
    if (location.state) {
      setInput(location.state);
    }

    //Get ContextList
    let url = "getContextList"
    let postdata = {
      userId: reduxAuth.userId,
      token: reduxAuth.token,
      environmentId: appcomponent.selectedEnvironment.tenantId,
    }

    axios.post(url, postdata)
      .then(contextList => {
        let clist = contextList.data.response[0];
        setEntityType(clist.entityType)
        setRole(clist.role)
        setUser(clist.user)
        setRelationship(clist.relationship)
        setLoader(false)
      })
      .catch(err => {
        if (typeof err.response != "object") {
          setErrorMessage({
            open: true,
            api: 'contextList',
            errmsg: "Couldn't found context list please sync the tenant..."
          })
          console.log(err);
        }
        else {
          if (err.response.status === 403) {
            dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
          }
        }
      });

    // dispatch(actions.attributelist());

  }, []);

  return (
        <div className={classes.root}>
          <Snackbar
            open={errorMessage.open} autoHideDuration={3000} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            onClose={handleClose}>
            <Alert
              severity="error"
              color="error"
              variant="filled">
              {errorMessage.errmsg != null ? errorMessage.errmsg : " NetWork Error:Please Check Your Internet Connection"}
            </Alert>
          </Snackbar>
          <Snackbar
            open={errorDuplicateMessage.open} autoHideDuration={3000} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            onClose={handleClose}>
            <Alert
              severity="error"
              color="error"
              variant="filled">
              Configuration Already Exists with the same Context. Please Update the existing one, or create another context!
        </Alert>
          </Snackbar>
          <form>
            <ThemeProvider theme={theme}>
              <Typography variant="subtitle1">
                {appcomponent.selectedApp.displayName}&gt;&gt;{appcomponent.selectedComponent.componentContextCode}
                {activeStep !== 0 ? <><Button
                  variant="contained"
                  color="primary"
                  size="small"
                  aria-label="View"
                  className={classes.btnformview}
                  // startIcon={<SpeakerNotesIcon />}
                  disabled={activeStep === 0 ? true : false}
                  startIcon={toggleView.view === 'form' ? <CodeIcon /> : <SpeakerNotesIcon />}
                  onClick={(event) => handleViewBtnClick(toggleView.view === 'form' ? 'json' : 'form')}
                >
                  {toggleView.view === 'form' ? 'JSON' : 'Form'}
                </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    className={classes.btnformview}
                    startIcon={reduxAuth.fullscreentoggle === false ? <FullscreenIcon /> : <FullscreenExitIcon />}
                    onClick={(event) => handlefullscreen(reduxAuth.fullscreentoggle === false ? "Fullscreen" : "FullscreenExit")}
                  >
                    {reduxAuth.fullscreentoggle === false ? "Fullscreen" : "FullscreenExit"}
                  </Button>
                </> : null}
              </Typography></ThemeProvider>
            {openJSONView.open || activeStep === 0 ?
              <Stepper alternativeLabel activeStep={activeStep} connector={<QontoConnector />}>
                {steps.map((label, Index) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper> : null}

            <div className={classes.div}>
              <div>
                <div>
                  {activeStep != 0 && openJSONView.open ?
                    <Button
                      title="Back"
                      variant='outlined'
                      color="primary"
                      onClick={handleBack}
                      className={classes.button}
                      style={{ fontSize: '0.700rem', fontWeight: 600 }}>
                      Back
                </Button> : null}

                  {activeStep === 0 || (activeStep !== 0 && openJSONView.open) ?
                    <Button
                      title={activeStep === steps.length - 1 ? "Save JSONData" : "Save Config Context"}
                      disabled={loader}
                      variant="contained"
                      color="primary"
                      style={{ fontSize: '0.700rem', fontWeight: 600 }}
                      onClick={(event) => handleNext(activeStep === steps.length - 1 ? 'Finish' : 'Next')}
                      className={classes.button}>
                      {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                    </Button> : null}


                  {activeStep === 0 ?
                    <Button
                      variant='outlined'
                      color="primary"
                      onClick={handleCancle}
                      className={classes.button}
                      style={{ fontSize: '0.700rem', fontWeight: 600 }}>
                      Cancel
                </Button> : null
                  }
                </div>
              </div>
            </div>

            {/* Select Context */}
            {activeStep === 0 ?
              <div style={{ marginTop: "40px" }}>
                {loader ? <CircularProgress className={classes.loader} /> :
                  <>
                    <TextField value={appcomponent.selectedComponent.componentContextCode} label=" Component" id="componentContextCode" size="small" disabled={true} style={{ width: 250, marginLeft: '25px', float: 'left' }} />

                    <Autocomplete
                      id="Select Domain"
                      options={Domain}
                      getOptionLabel={option => option}
                      renderInput={params => <TextField {...params} style={{ width: 250, float: 'left', marginLeft: '25px' }} label="Select Domain" />}
                      value={contextdp.domain}
                      onChange={handlecontextdropdown} />

                    <Autocomplete
                      id="Select EntityType"
                      options={EntityType}
                      getOptionLabel={option => option}
                      renderInput={params => <TextField {...params} style={{ width: 250, marginLeft: '25px' }} label="Select EntityType" />}
                      value={contextdp.entityType}
                      onChange={handlecontextdropdown} />


                    <Autocomplete
                      id="Select Relationship"
                      options={Relationship}
                      getOptionLabel={option => option}
                      renderInput={params => <TextField {...params} label="Select Relationship" style={{ width: 250, marginTop: '40px', marginLeft: '25px', float: 'left' }} />}
                      value={contextdp.relationship}
                      onChange={handlecontextdropdown} />


                    <Autocomplete
                      id="Select Role"
                      options={Role}
                      getOptionLabel={option => option}
                      renderInput={params => <TextField {...params} label="Select Role" style={{ width: 250, marginTop: '40px', marginLeft: '25px', float: 'left' }} />}
                      value={contextdp.role}
                      onChange={handlecontextdropdown} />

                    <Autocomplete
                      id="select User"
                      name="user"
                      options={User}
                      getOptionLabel={option => option}
                      renderInput={params => <TextField {...params} label="Select User" style={{ width: 250, marginTop: '40px', marginLeft: '25px' }} />}
                      value={contextdp.user}
                      onChange={handlecontextdropdown} />
                  </>
                }
              </div>
              : null}

            {openJSONView.open ?
              <main>
                <div style={{ marginTop: "40px" }}>
                  <Editor
                    mode='code'
                    ace={ace}
                    value={location.state !== undefined ? location.state.jsonDocument.data.contexts[0].jsonData : change.jsonData}
                    onChange={(event) => handleOnChange(event)}>
                  </Editor>
                </div>
              </main> : null}


            {activeStep !== 0 && !openJSONView.open ? <div style={{ overflowY: 'auto', backgroundColor: '#FFFFFF' }}>
              {appcomponent.selectedComponent.componentContextCode === "rock-navmenu" ? <NavmenuForm data={addConfigResponse.data.response} /> : null}
              {appcomponent.selectedComponent.componentContextCode === "rock-entity-create" ? <EntityCreateForm data={addConfigResponse.data.response} /> : null}
              {appcomponent.selectedComponent.componentContextCode === "rock-wizard-entity-create" ? <WizardEntityCreateForm data={addConfigResponse.data.response} /> : null}
              {appcomponent.selectedComponent.componentContextCode === "rock-entity-header" ? <EntityHeaderForm data={addConfigResponse.data.response} /> : null}
              {appcomponent.selectedComponent.componentContextCode === "rock-entity-search-result" ? <EntitySearchResultForm data={addConfigResponse.data.response} /> : null}
              {appcomponent.selectedComponent.componentContextCode !== "rock-navmenu" &&
                appcomponent.selectedComponent.componentContextCode !== "rock-entity-create" &&
                appcomponent.selectedComponent.componentContextCode !== "rock-wizard-entity-create" &&
                appcomponent.selectedComponent.componentContextCode !== "rock-entity-header" &&
                appcomponent.selectedComponent.componentContextCode !== "rock-entity-search-result" ?
                setOpenJSONView({
                  open: true
                })

                : null}
            </div> : null
            }
          </form>
        </div>
  );
}

//Compbobox

/* <Autocomplete
    id="Select Domain"
    options={top100Films}
    getOptionLabel={option => option.title}
    style={{float:'left'}}
    renderInput={params => <TextField {...params} label="Select Domain" style={{marginLeft:'35px'}} className={classes.dropdown} />}/>

  <Autocomplete
    id="Select EntityType"
    options={top100Films}
    getOptionLabel={option => option.title}
    style={{float:'left'}}
    renderInput={params => <TextField {...params} label="Select EntityType" className={classes.dropdown} />}/>

  <Autocomplete
    id="Select Relationship"
    options={top100Films}
    getOptionLabel={option => option.title}
    style={{float:'left'}}
    renderInput={params => <TextField {...params} label="Select Relationship" className={classes.dropdown}/> } />

  <Autocomplete
    id="Select Role"
    options={top100Films}
    getOptionLabel={option => option.title}
    style={{float:'left'}}
    renderInput={params => <TextField {...params} label="Select Role" style={{marginLeft:'35px'}} className={classes.dropdown}/> } />

  <Autocomplete
    id="Select User"
    options={top100Films}
    getOptionLabel={option => option.title}
    style={{float:'left'}}
    renderInput={params => <TextField {...params} label="Select User" className={classes.dropdown}/>} /> */
